import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import HomeBase from '@/components/home/HomeBase'
import MemberBase from '@/components/member/MemberBase'
import SellerBase from '@/components/seller/SellerBase'
import DistributorBase from '@/components/distributor/DistributorBase'
import FuwuManageBase from '@/components/fuwu_manage/FuwuManageBase'
import FuwuBase from '@/components/fuwu/FuwuBase'
import UAParser from 'ua-parser-js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    let condition1 = window.location.href.search('/home/storedetail')
    let condition2 = window.location.href.search('/member/o2o_errand')
    let condition3 = window.location.href.search('/home/storelist')
    let condition4 = window.location.href.search('/home/goodsdetail')


    if(condition1 === -1 && condition2 === -1 && condition3 === -1 && condition4 === -1) {
      store.commit('resetCommonStoreList')
    }
    document.querySelector('#app').scrollTop = 0
  },
  routes: [
    {
      path: '',
      redirect: '/member/home',
      meta: {
        footer: {
          show: true
        }
      }
    },
    {
        path: '/startapp',
        name: 'Startapp',
        component: resolve => (require(['@/components/Startapp'], resolve)),
        meta: { footer: { show: false } }
    },
    {
      path: '/home/',
      component: HomeBase,
      children: [
        // 外卖
        // 首页
        { path: 'waimai', name: 'HomeWaimaiIndex', component: resolve => (require(['@/components/home/waimai/Index'], resolve)), meta: { footer: { show: true } } },
        // 地图
        { path: 'map', name: 'HomeMap', component: resolve => (require(['@/components/home/map/Map'], resolve)), meta: { footer: { show: true } } },
        // 注册协议
        { path: 'document', name: 'HomeDocument', component: resolve => (require(['@/components/home/article/Document'], resolve)), meta: { footer: { show: false } } },
        // 文章分类
        { path: 'article_class', name: 'HomeArticleclass', component: resolve => (require(['@/components/home/article/Articleclass'], resolve)), meta: { footer: { show: true } } },
        // 文章列表
        { path: 'article_list', name: 'HomeArticlelist', component: resolve => (require(['@/components/home/article/Articlelist'], resolve)), meta: { footer: { show: true } } },
        // 文章详情
        { path: 'article_detail', name: 'HomeArticledetail', component: resolve => (require(['@/components/home/article/Articledetail'], resolve)), meta: { footer: { show: true } } },
        // 用户注册
        { path: 'memberregister', name: 'HomeMemberRegister', component: resolve => (require(['@/components/home/memberregister/Register'], resolve)), meta: { footer: { show: false } } },
        // 用户绑定
        { path: 'memberbind', name: 'HomeMemberBind', component: resolve => (require(['@/components/home/memberbind/Bind'], resolve)), meta: { footer: { show: true } } },
        // 用户登录
        { path: 'memberlogin', name: 'HomeMemberLogin', component: resolve => (require(['@/components/home/memberlogin/Login'], resolve)), meta: { footer: { show: false } } },
        // 卖家登录
        { path: 'sellerlogin', name: 'HomeSellerLogin', component: resolve => (require(['@/components/home/sellerlogin/Login'], resolve)), meta: { footer: { show: true } } },
        // 忘记密码
        { path: 'memberforget', name: 'HomeMemberForget', component: resolve => (require(['@/components/home/memberforget/Forget'], resolve)), meta: { footer: { show: true } } },
        // 购物车
        { path: 'cart', name: 'HomeCart', component: resolve => (require(['@/components/home/cart/Cart'], resolve)), meta: { footer: { show: true } } },
        // 搜索
        { path: 'search', name: 'HomeSearch', component: resolve => (require(['@/components/home/search/Search'], resolve)), meta: { footer: { show: true } } },
        // 附近店铺
        { path: 'storelist', name: 'HomeStorelist', component: resolve => (require(['@/components/home/storelist/Storelist'], resolve)), meta: { footer: { show: true } } },
        // 店铺详情
        { path: 'storedetail', name: 'HomeStoredetail', component: resolve => (require(['@/components/home/storedetail/Storedetail'], resolve)), meta: { footer: { show: false } } },
        // 店铺送出訂單
        { path: 'storeSend', name: 'HomeStoreSend', component: resolve => (require(['@/components/home/storedetail/StoreSend'], resolve)), meta: { footer: { show: false } } },
        // 店铺详情
        { path: 'goodsdetail', name: 'HomeGoodsdetail', component: resolve => (require(['@/components/home/goodsdetail/Goodsdetail'], resolve)), meta: { footer: { show: false } } },
        // 店铺代金券
        { path: 'storevoucher', name: 'HomeStoreVoucher', component: resolve => (require(['@/components/home/storedetail/StoreVoucher'], resolve)), meta: { footer: { show: false } } },
        // 积分兑换商品
        { path: 'pointsgoods', name: 'HomePointsgoods', component: resolve => (require(['@/components/home/pointsgoods/Index'], resolve)), meta: { footer: { show: true } } },
        // 积分兑换商品
        { path: 'point_prod', name: 'HomePointProd', component: resolve => (require(['@/components/home/pointsgoods/PointProd'], resolve)), meta: { footer: { show: true } } },
        // 积分兑换商品
        { path: 'point_voucher', name: 'HomePointVoucher', component: resolve => (require(['@/components/home/pointsgoods/PointVoucher'], resolve)), meta: { footer: { show: true } } },
        // 积分兑换商品详情页
        { path: 'pointsgoods_detail', name: 'HomePointsgoodsDetail', component: resolve => (require(['@/components/home/pointsgoods/Detail'], resolve)), meta: { footer: { show: false } } },
        // 红包兑换商品详情页
        { path: 'bonus_detail', name: 'HomeBonusDetail', component: resolve => (require(['@/components/home/bonus/Detail'], resolve)), meta: { footer: { show: false } } },
        // 积分活动列表
        { path: 'marketmanagelist', name: 'HomeMarketmanagelist', component: resolve => (require(['@/components/home/marketmanage/Marketmanagelist'], resolve)), meta: { footer: { show: false } } },
        // 刮刮卡
        { path: 'marketcard', name: 'HomeMarketcard', component: resolve => (require(['@/components/home/marketmanage/Marketcard'], resolve)), meta: { footer: { show: false } } },
        // 生肖翻翻看
        { path: 'marketzodiac', name: 'HomeMarketzodiac', component: resolve => (require(['@/components/home/marketmanage/Marketzodiac'], resolve)), meta: { footer: { show: false } } },
        // 大转盘
        { path: 'marketwheel', name: 'HomeMarketwheel', component: resolve => (require(['@/components/home/marketmanage/Marketwheel'], resolve)), meta: { footer: { show: false } } },
        // 砸金蛋
        { path: 'marketegg', name: 'HomeMarketegg', component: resolve => (require(['@/components/home/marketmanage/Marketegg'], resolve)), meta: { footer: { show: false } } },
        //Loading
      ]
    },

    {
      path: '/member/',
      component: MemberBase,
      meta: {
        auth: 'member'
      },
      children: [
        // 首页
        { path: 'home', name: 'HomeIndex', component: resolve => (require(['@/components/home/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 用户中心
        { path: 'index', name: 'MemberIndex', component: resolve => (require(['@/components/member/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 我的钱包
        { path: 'account', name: 'MemberAccount', component: resolve => (require(['@/components/member/account/Account'], resolve)), meta: { footer: { show: true } } },
        // 资金明细
        { path: 'predeposit_list', name: 'MemberPredepositList', component: resolve => (require(['@/components/member/predeposit/PredepositList'], resolve)), meta: { footer: { show: true } } },
        // 充值卡明细
        { path: 'recharge_card_list', name: 'MemberRechargeCardList', component: resolve => (require(['@/components/member/predeposit/RechargeCardList'], resolve)), meta: { footer: { show: true } } },
        // 提现明细
        { path: 'withdraw_list', name: 'MemberWithdrawList', component: resolve => (require(['@/components/member/withdraw/WithdrawList'], resolve)), meta: { footer: { show: true } } },
        // 充值明细
        { path: 'recharge_list', name: 'MemberRechargeList', component: resolve => (require(['@/components/member/recharge/RechargeList'], resolve)), meta: { footer: { show: true } } },
        // 代金券列表
        { path: 'voucher_list', name: 'MemberVoucherList', component: resolve => (require(['@/components/member/voucher/VoucherList'], resolve)), meta: { footer: { show: true } } },
        // 消息列表
        { path: 'notice_list', name: 'MemberNoticeList', component: resolve => (require(['@/components/member/notice/NoticeList'], resolve)), meta: { footer: { show: true } } },
        // 账号设置
        { path: 'setting', name: 'MemberSetting', component: resolve => (require(['@/components/member/setting/AccountSet'], resolve)), meta: { footer: { show: true } } },
        // 个人信息
        { path: 'profile_set', name: 'MemberProfileSet', component: resolve => (require(['@/components/member/profile/ProfileSet'], resolve)), meta: { footer: { show: true } } },
        // 积分明细
        { path: 'point_list', name: 'MemberPointList', component: resolve => (require(['@/components/member/point/PointList'], resolve)), meta: { footer: { show: true } } },
        // 签到送积分
        { path: 'point_signin', name: 'MemberPointSignin', component: resolve => (require(['@/components/member/point/PointSignin'], resolve)), meta: { footer: { show: true } } },
        // 高德地图
        { path: 'gaode_map', name: 'MemberGaodeMap', component: resolve => (require(['@/components/member/address/GaodeMap'], resolve)), meta: { footer: { show: false } } },
        // 地址列表
        { path: 'address_list', name: 'MemberAddressList', component: resolve => (require(['@/components/member/address/AddressList'], resolve)), meta: { footer: { show: true } } },
        // 地址编辑
        { path: 'address_form', name: 'MemberAddressForm', component: resolve => (require(['@/components/member/address/AddressForm'], resolve)), meta: { footer: { show: false } } },
        // 提现账户列表
        { path: 'bank_list', name: 'MemberBankList', component: resolve => (require(['@/components/member/bank/BankList'], resolve)), meta: { footer: { show: true } } },
        // 提现账户编辑
        { path: 'bank_form', name: 'MemberBankForm', component: resolve => (require(['@/components/member/bank/BankForm'], resolve)), meta: { footer: { show: true } } },
        // 退款列表
        { path: 'refund_list', name: 'MemberRefundList', component: resolve => (require(['@/components/member/refund/RefundList'], resolve)), meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'refund_form', name: 'MemberRefundForm', component: resolve => (require(['@/components/member/refund/RefundForm'], resolve)), meta: { footer: { show: true } } },
        // 退款详情
        { path: 'refund_view', name: 'MemberRefundView', component: resolve => (require(['@/components/member/refund/RefundView'], resolve)), meta: { footer: { show: true } } },
        // 退货编辑
        { path: 'return_form', name: 'MemberReturnForm', component: resolve => (require(['@/components/member/return/ReturnForm'], resolve)), meta: { footer: { show: true } } },
        // 发票列表
        { path: 'invoice_list', name: 'MemberInvoiceList', component: resolve => (require(['@/components/member/invoice/InvoiceList'], resolve)), meta: { footer: { show: true } } },
        // 发票编辑
        { path: 'invoice_form', name: 'MemberInvoiceForm', component: resolve => (require(['@/components/member/invoice/InvoiceForm'], resolve)), meta: { footer: { show: true } } },
        // 浏览历史页面
        { path: 'browse_list', name: 'MemberBrowseList', component: resolve => (require(['@/components/member/browse/BrowseList'], resolve)), meta: { footer: { show: true } } },
        // 意见反馈
        { path: 'feedback', name: 'MemberFeedback', component: resolve => (require(['@/components/member/feedback/Feedback'], resolve)), meta: { footer: { show: true } } },
        // 確認訂單
        { path: 'buystep0', name: 'MemberBuyStep00', component: resolve => (require(['@/components/member/buy/step00'], resolve)), meta: { footer: { show: false } } },
        // 下单界面
        { path: 'buystep1', name: 'MemberBuyStep01', component: resolve => (require(['@/components/member/buy/step01'], resolve)), meta: { footer: { show: false } } },
        // 积分商品下单
        { path: 'pointsbuystep1', name: 'MemberPointsBuyStep1', component: resolve => (require(['@/components/member/pointsbuy/step1'], resolve)), meta: { footer: { show: false } } },
        // 积分商品购物车
        { path: 'pointscart', name: 'MemberPointsCart', component: resolve => (require(['@/components/member/pointscart/Cart'], resolve)), meta: { footer: { show: true } } },
        // 积分订单列表
        { path: 'pointsorder_list', name: 'MemberPointsOrderList', component: resolve => (require(['@/components/member/pointsorder/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 积分订单详情
        { path: 'pointsorder_detail', name: 'MemberPointsOrderDetail', component: resolve => (require(['@/components/member/pointsorder/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 配送员投诉
        { path: 'o2o_complaint', name: 'MemberO2oComplaint', component: resolve => (require(['@/components/member/o2o/Complaint'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_list', name: 'MemberComplaintList', component: resolve => (require(['@/components/member/complaint/ComplaintList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_form', name: 'MemberComplaintForm', component: resolve => (require(['@/components/member/complaint/ComplaintForm'], resolve)), meta: { footer: { show: true } } },
        // 支付界面
        { path: 'buypay', name: 'MemberBuyPay', component: resolve => (require(['@/components/member/buy/payment'], resolve)), meta: { footer: { show: false } }, props: (route) => route.params },
        // 我的订单
        { path: 'order_list', name: 'MemberOrderList', component: resolve => (require(['@/components/member/order/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 我的收藏
        { path: 'favorite', name: 'MemberFavorite', component: resolve => (require(['@/components/member/favorite/Favorite'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'order_detail', name: 'MemberOrderDetail', component: resolve => (require(['@/components/member/order/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 评价订单
        { path: 'order_evaluate', name: 'MemberOrderEvaluate', component: resolve => (require(['@/components/member/order/OrderEvaluate'], resolve)), meta: { footer: { show: true } } },
        // 用户订单评价列表
        { path: 'evaluate_list', name: 'MemberEvaluateList', component: resolve => (require(['@/components/member/evaluate/EvaluateList'], resolve)), meta: { footer: { show: true } } },
        // 推广海报
        { path: 'inviter_manage', name: 'MemberInviterManage', component: resolve => (require(['@/components/member/inviter/InviterManage'], resolve)), meta: { footer: { show: true } } },
        // 推广会员
        { path: 'inviter_user', name: 'MemberInviterUser', component: resolve => (require(['@/components/member/inviter/InviterUser'], resolve)), meta: { footer: { show: true } } },
        // 推广佣金
        { path: 'inviter_order', name: 'MemberInviterOrder', component: resolve => (require(['@/components/member/inviter/InviterOrder'], resolve)), meta: { footer: { show: true } } },
        // 跑腿
        { path: 'o2o_errand', name: 'MemberO2oErrand', component: resolve => (require(['@/components/member/o2o/O2oErrand'], resolve)), meta: { footer: { show: true } } },
        // 跑腿
        { path: 'o2o_errand_send', name: 'MemberO2oErrandSend', component: resolve => (require(['@/components/member/o2o/O2oErrandSend'], resolve)), meta: { footer: { show: true } } },
        // 跑腿
        { path: 'o2o_errand_buy', name: 'MemberO2oErrandBuy', component: resolve => (require(['@/components/member/o2o/O2oErrandBuy'], resolve)), meta: { footer: { show: false } } },
        // 我的订单
        { path: 'o2o_errand_order_list', name: 'MemberO2oErrandOrderList', component: resolve => (require(['@/components/member/o2o/O2oErrandOrderList'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'o2o_errand_order_detail', name: 'MemberO2oErrandOrderDetail', component: resolve => (require(['@/components/member/o2o/O2oErrandOrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 服务下单
        { path: 'o2o_fuwu_buy', name: 'MemberO2oFuwuBuy', component: resolve => (require(['@/components/member/o2o_fuwu_buy/O2oFuwuBuy'], resolve)), meta: { footer: { show: false } } },
        // 我的订单
        { path: 'o2o_fuwu_order_list', name: 'MemberO2oFuwuOrderList', component: resolve => (require(['@/components/member/o2o_fuwu_order/O2oFuwuOrderList'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'o2o_fuwu_order_detail', name: 'MemberO2oFuwuOrderDetail', component: resolve => (require(['@/components/member/o2o_fuwu_order/O2oFuwuOrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 活动记录
        { path: 'marketmanagelog', name: 'MemberMarketmanagelog', component: resolve => (require(['@/components/member/marketmanagelog/Marketmanagelog'], resolve)), meta: { footer: { show: true } } },
        // 红包领取记录
        { path: 'bonusreceive', name: 'MemberBonusreceive', component: resolve => (require(['@/components/member/bonusreceive/Bonusreceive'], resolve)), meta: { footer: { show: true } } },
        // 会员认证页面
        { path: 'auth', name: 'MemberAuth', component: resolve => (require(['@/components/member/auth/Auth'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_1', name: 'SellerJoinin1', component: resolve => (require(['@/components/member/sellerjoinin/Step1'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_2', name: 'SellerJoinin2', component: resolve => (require(['@/components/member/sellerjoinin/Step2'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_3', name: 'SellerJoinin3', component: resolve => (require(['@/components/member/sellerjoinin/Step3'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_4', name: 'SellerJoinin4', component: resolve => (require(['@/components/member/sellerjoinin/Step4'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_5', name: 'SellerJoinin5', component: resolve => (require(['@/components/member/sellerjoinin/Step5'], resolve)), meta: { footer: { show: true } } },
        // 新增信用卡
        { path: 'add_credit_card', name: 'MemberAddCredit', component: resolve => (require(['@/components/member/payment/AddCredit'], resolve)), meta: { footer: { show: false } } },
        // 店铺信用卡
        { path: 'list_credit_card', name: 'MemberCredits', component: resolve => (require(['@/components/member/payment/ListCredit'], resolve)), meta: { footer: { show: false } } }
      ]
    },
    {
      path: '/seller/',
      component: SellerBase,
      children: [
        // 卖家中心
        { path: 'index', name: 'SellerIndex', component: resolve => (require(['@/components/seller/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 卖家中心
        { path: 'dada_shop', name: 'SellerDadaShop', component: resolve => (require(['@/components/seller/dada/Shop'], resolve)), meta: { footer: { show: true } } },
        // 店铺消息列表
        { path: 'notice_list', name: 'SellerNoticeList', component: resolve => (require(['@/components/seller/notice/NoticeList'], resolve)), meta: { footer: { show: true } } },
        // 代金券列表
        { path: 'voucher_list', name: 'SellerVoucherList', component: resolve => (require(['@/components/seller/voucher/VoucherList'], resolve)), meta: { footer: { show: true } } },
        // 编辑代金券
        { path: 'voucher_form', name: 'SellerVoucherForm', component: resolve => (require(['@/components/seller/voucher/VoucherForm'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品管理
        { path: 'goodsonline', name: 'SellerGoodsonline', component: resolve => (require(['@/components/seller/goods/Goodsonline'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品上传步骤1
        { path: 'goods_form_1', name: 'SellerGoodsForm1', component: resolve => (require(['@/components/seller/goods/GoodsForm1'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品上传步骤2
        { path: 'goods_form_2', name: 'SellerGoodsForm2', component: resolve => (require(['@/components/seller/goods/GoodsForm2'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品上传步骤3
        { path: 'goods_form_3', name: 'SellerGoodsForm3', component: resolve => (require(['@/components/seller/goods/GoodsForm3'], resolve)), meta: { footer: { show: true } } },
        // 商品规格
        { path: 'spec', name: 'SellerSpec', component: resolve => (require(['@/components/seller/spec/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺分类列表
        { path: 'goodsclass_list', name: 'SellerGoodsClassList', component: resolve => (require(['@/components/seller/goodsclass/GoodsClassList'], resolve)), meta: { footer: { show: true } } },
        // 店铺分类编辑
        { path: 'goodsclass_form', name: 'SellerGoodsClassForm', component: resolve => (require(['@/components/seller/goodsclass/GoodsClassForm'], resolve)), meta: { footer: { show: true } } },
        // 退款列表
        { path: 'refund_list', name: 'SellerRefundList', component: resolve => (require(['@/components/seller/refund/RefundList'], resolve)), meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'refund_form', name: 'SellerRefundForm', component: resolve => (require(['@/components/seller/refund/RefundForm'], resolve)), meta: { footer: { show: true } } },
        // 退款详情
        { path: 'refund_view', name: 'SellerRefundView', component: resolve => (require(['@/components/seller/refund/RefundView'], resolve)), meta: { footer: { show: true } } },
        // 评价列表
        { path: 'evaluate_list', name: 'SellerEvaluateList', component: resolve => (require(['@/components/seller/evaluate/EvaluateList'], resolve)), meta: { footer: { show: true } } },
        // 卖家订单列表
        { path: 'orderlist', name: 'SellerOrderList', component: resolve => (require(['@/components/seller/order/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'order_detail', name: 'SellerOrderDetail', component: resolve => (require(['@/components/seller/order/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 订单指派配送员
        { path: 'order_distributor', name: 'SellerOrderDistributor', component: resolve => (require(['@/components/seller/order/OrderDistributor'], resolve)), meta: { footer: { show: true } } },
        // 卖家结算单
        { path: 'billlist', name: 'SellerBillList', component: resolve => (require(['@/components/seller/bill/BillList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_list', name: 'SellerComplaintList', component: resolve => (require(['@/components/seller/complaint/ComplaintList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_form', name: 'SellerComplaintForm', component: resolve => (require(['@/components/seller/complaint/ComplaintForm'], resolve)), meta: { footer: { show: true } } },
        // 店铺概况
        { path: 'statistics_general', name: 'SellerStatisticsGeneral', component: resolve => (require(['@/components/seller/statisticsgeneral/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺O2O设置
        { path: 'o2o', name: 'SellerO2O', component: resolve => (require(['@/components/seller/o2o/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺基本信息设置管理页
        { path: 'setting_index', name: 'SellerSettingIndex', component: resolve => (require(['@/components/seller/setting/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺基本信息设置
        { path: 'setting_info', name: 'SellerSettingInfo', component: resolve => (require(['@/components/seller/setting/Info'], resolve)), meta: { footer: { show: true } } },
        // 店铺O2O配送员
        { path: 'o2o_distributor', name: 'SellerO2ODistributor', component: resolve => (require(['@/components/seller/o2o/Distributor'], resolve)), meta: { footer: { show: true } } },
        // 店铺O2O配送员编辑
        { path: 'o2o_distributor_form', name: 'SellerO2ODistributorForm', component: resolve => (require(['@/components/seller/o2o/DistributorForm'], resolve)), meta: { footer: { show: true } } },
        // 店铺O2O配送员结算
        { path: 'o2o_bill_list', name: 'SellerO2OBillList', component: resolve => (require(['@/components/seller/o2o/BillList'], resolve)), meta: { footer: { show: true } } },
        // 店铺O2O配送员投诉
        { path: 'o2o_complaint', name: 'SellerO2OComplaint', component: resolve => (require(['@/components/seller/o2o/Complaint'], resolve)), meta: { footer: { show: true } } },
        // 店铺分销页面
        { path: 'inviter', name: 'SellerInviter', component: resolve => (require(['@/components/seller/inviter/Index'], resolve)), meta: { footer: { show: true } } },
        // 分销订单管理
        { path: 'inviter_orderlist', name: 'SellerInviterOrderList', component: resolve => (require(['@/components/seller/inviter/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 分销商品管理
        { path: 'inviter_goodslist', name: 'SellerInviterGoodsList', component: resolve => (require(['@/components/seller/inviter/GoodsList'], resolve)), meta: { footer: { show: true } } },
        // 分销商品添加/编辑
        { path: 'inviter_goodsform', name: 'SellerInviterGoodsForm', component: resolve => (require(['@/components/seller/inviter/GoodsForm'], resolve)), meta: { footer: { show: true } } },
        // 子账户管理界面
        { path: 'account', name: 'SellerAccount', component: resolve => (require(['@/components/seller/account/Index'], resolve)), meta: { footer: { show: true } } },
        // 子账户列表
        { path: 'account_list', name: 'SellerAccountList', component: resolve => (require(['@/components/seller/account/AccountList'], resolve)), meta: { footer: { show: true } } },
        // 添加子账户
        { path: 'account_form', name: 'SellerAccountForm', component: resolve => (require(['@/components/seller/account/AccountForm'], resolve)), meta: { footer: { show: true } } },
        // 账户组列表
        { path: 'accountgroup_list', name: 'SellerAccountGroupList', component: resolve => (require(['@/components/seller/account/AccountGroupList'], resolve)), meta: { footer: { show: true } } },
        // 账户日志记录
        { path: 'log_list', name: 'SellerLogList', component: resolve => (require(['@/components/seller/log/LogList'], resolve)), meta: { footer: { show: true } } },
        // 账户消费记录
        { path: 'cost_list', name: 'SellerCostList', component: resolve => (require(['@/components/seller/cost/CostList'], resolve)), meta: { footer: { show: true } } },
        // 店铺资金
        { path: 'money', name: 'SellerMoney', component: resolve => (require(['@/components/seller/money/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺资金记录
        { path: 'moneylog_list', name: 'SellerMoneyLogList', component: resolve => (require(['@/components/seller/money/LogList'], resolve)), meta: { footer: { show: true } } },
        // 店铺资金提现记录
        { path: 'moneywithdraw_list', name: 'SellerMoneyWithdrawList', component: resolve => (require(['@/components/seller/money/WithdrawList'], resolve)), meta: { footer: { show: true } } },
        // 店铺保证金
        { path: 'deposit', name: 'SellerDeposit', component: resolve => (require(['@/components/seller/deposit/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺保证金记录
        { path: 'deposit_list', name: 'SellerDepositList', component: resolve => (require(['@/components/seller/deposit/DepositList'], resolve)), meta: { footer: { show: true } } },
        // 店铺保证金提现记录
        { path: 'depositwithdraw_list', name: 'SellerDepositWithdrawList', component: resolve => (require(['@/components/seller/deposit/WithdrawList'], resolve)), meta: { footer: { show: true } } }
      ]
    },
    {
      // 配送员登录页
      path: '/distributor/login', name: 'DistributorLogin', component: resolve => (require(['@/components/distributor/login/Index'], resolve)), meta: { footer: { show: false } },
    },
    {
      path: '/distributor/',
      component: DistributorBase,
      children: [
        // 配送员首页
        { path: 'home', name: 'DistributorHome', component: resolve => (require(['@/components/distributor/home/Index'], resolve)), meta: { footer: { show: true } } },
        // 跑腿抢单页
        { path: 'errand', name: 'DistributorErrand', component: resolve => (require(['@/components/distributor/home/Errand'], resolve)), meta: { footer: { show: true } } },
        // 配送员注册页
        { path: 'register', name: 'DistributorRegister', component: resolve => (require(['@/components/distributor/register/Register'], resolve)), meta: { footer: { show: false }, guest: true } },
        // 订单地图页
        { path: 'map', name: 'DistributorMap', component: resolve => (require(['@/components/distributor/map/Index'], resolve)), meta: { footer: { show: true } } },
        // 點數紀錄
        { path: 'dian_shu_ji_lu', name: 'DianShuJiLu', component: resolve => (require(['@/components/distributor/dianShu/index'], resolve)), meta: { footer: { show: true } } },
        // 配送员中心
        { path: 'user', name: 'DistributorUser', component: resolve => (require(['@/components/distributor/user/Index'], resolve)), meta: { footer: { show: true } } },
        // 配送订单
        { path: 'order_list', name: 'DistributorOrderList', component: resolve => (require(['@/components/distributor/user/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 跑腿订单列表
        { path: 'errand_order_list', name: 'DistributorErrandOrderList', component: resolve => (require(['@/components/distributor/user/ErrandOrderList'], resolve)), meta: { footer: { show: true } } },
        // 跑腿订单详情
        { path: 'errand_order_detail', name: 'DistributorErrandOrderDetail', component: resolve => (require(['@/components/distributor/user/ErrandOrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 配送员信息
        { path: 'information', name: 'DistributorInformation', component: resolve => (require(['@/components/distributor/user/Information'], resolve)), meta: { footer: { show: true } } },
        // 配送员认证
        { path: 'authentication', name: 'DistributorAuthentication', component: resolve => (require(['@/components/distributor/user/Authentication'], resolve)), meta: { footer: { show: true } } },
        // 配送订单统计
        { path: 'record_statis', name: 'DistributorRecordStatis', component: resolve => (require(['@/components/distributor/user/RecordStatis'], resolve)), meta: { footer: { show: true } } },
        // 配送结算列表
        { path: 'settle_list', name: 'DistributorSettleList', component: resolve => (require(['@/components/distributor/user/SettleList'], resolve)), meta: { footer: { show: true } } },
        // 配送员通知
        { path: 'notice_list', name: 'DistributorNoticeList', component: resolve => (require(['@/components/distributor/user/NoticeList'], resolve)), meta: { footer: { show: true } } },
        // 配送员账号安全
        { path: 'account_safe', name: 'DistributorAccountSafe', component: resolve => (require(['@/components/distributor/user/AccountSafe'], resolve)), meta: { footer: { show: true } } },
        // 配送设置
        { path: 'system_set', name: 'DistributorSystemSet', component: resolve => (require(['@/components/distributor/user/SystemSet'], resolve)), meta: { footer: { show: true } } }
      ]
    },
    {
      path: '/fuwu_manage/',
      component: FuwuManageBase,
      children: [
        // 服务机构登录
        { path: 'login', name: 'FuwuLogin', component: resolve => (require(['@/components/fuwu_manage/login/Login'], resolve)), meta: { footer: { show: false } } },
        // 服务机构注册
        { path: 'register', name: 'FuwuRegister', component: resolve => (require(['@/components/fuwu_manage/register/Register'], resolve)), meta: { footer: { show: false } } },
        // 服务机构中心
        { path: 'info', name: 'FuwuManageInfo', component: resolve => (require(['@/components/fuwu_manage/info/Info'], resolve)), meta: { footer: { show: true } } },
        // 服务机构基本信息
        { path: 'info_base', name: 'FuwuManageInfoBase', component: resolve => (require(['@/components/fuwu_manage/info/InfoBase'], resolve)), meta: { footer: { show: false } } },
        // 服务机构经营信息
        { path: 'info_operate', name: 'FuwuManageInfoOperate', component: resolve => (require(['@/components/fuwu_manage/info/InfoOperate'], resolve)), meta: { footer: { show: false } } },
        // 服务机构认证
        { path: 'authen', name: 'FuwuManageAuthen', component: resolve => (require(['@/components/fuwu_manage/authen/Authen'], resolve)), meta: { footer: { show: false } } },
        // 服务机构账号设置
        { path: 'account', name: 'FuwuManageAccount', component: resolve => (require(['@/components/fuwu_manage/account/Account'], resolve)), meta: { footer: { show: false } } },
        // 服务机构通知
        { path: 'notice_list', name: 'FuwuManageNoticeList', component: resolve => (require(['@/components/fuwu_manage/notice/NoticeList'], resolve)), meta: { footer: { show: false } } },
        // 服务机构商品列表
        { path: 'goods_list', name: 'FuwuManageGoodsList', component: resolve => (require(['@/components/fuwu_manage/goods/GoodsList'], resolve)), meta: { footer: { show: false } } },
        // 服务机构商品编辑
        { path: 'goods_form', name: 'FuwuManageGoodsForm', component: resolve => (require(['@/components/fuwu_manage/goods/GoodsForm'], resolve)), meta: { footer: { show: false } } },
        // 服务机构订单列表
        { path: 'order_list', name: 'FuwuManageOrderList', component: resolve => (require(['@/components/fuwu_manage/order/OrderList'], resolve)), meta: { footer: { show: false } } },
        // 服务机构订单详情
        { path: 'order_detail', name: 'FuwuManageOrderDetail', component: resolve => (require(['@/components/fuwu_manage/order/OrderDetail'], resolve)), meta: { footer: { show: false } } },
        // 服务机构资金记录
        { path: 'money_log_list', name: 'FuwuManageMoneyLogList', component: resolve => (require(['@/components/fuwu_manage/money/MoneyLogList'], resolve)), meta: { footer: { show: false } } },
        // 服务机构提现记录
        { path: 'withdraw_list', name: 'FuwuManageWithdrawList', component: resolve => (require(['@/components/fuwu_manage/money/WithdrawList'], resolve)), meta: { footer: { show: false } } }
      ]
    },
    {
      path: '/fuwu/',
      component: FuwuBase,
      children: [
        // 服务首页
        { path: 'index', name: 'FuwuIndex', component: resolve => (require(['@/components/fuwu/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 服务分类
        { path: 'fuwu_class', name: 'FuwuClass', component: resolve => (require(['@/components/fuwu/fuwu_class/FuwuClass'], resolve)), meta: { footer: { show: true } } },
        // 服务商品详情
        { path: 'goodsdetail', name: 'FuwuGoodsDetail', component: resolve => (require(['@/components/fuwu/goodsdetail/GoodsDetail'], resolve)), meta: { footer: { show: false } } },
        // 服务机构列表
        { path: 'organizationlist', name: 'FuwuOrganizationList', component: resolve => (require(['@/components/fuwu/organizationlist/OrganizationList'], resolve)), meta: { footer: { show: true } } },
        // 服务机构详情
        { path: 'organizationdetail', name: 'FuwuOrganizationDetail', component: resolve => (require(['@/components/fuwu/organizationdetail/OrganizationDetail'], resolve)), meta: { footer: { show: true } } }
      ]
    }

  ]
})

const redirect_home_route_names = {
  'member': 'HomeIndex',
  'distributor': 'DistributorHome'
}

const redirect_login_route_names = {
  'member': 'HomeMemberLogin',
  'distributor': 'DistributorLogin'
}

const is_authenticated = (type) => {
  const tokens = {
    'member': store.state.member.token || null,
    'distributor': store.state.distributor.token || null
  }

  return tokens[type] !== null
}

const verifyToken = (to, type) => {
  const regex = new RegExp('^/' + type + '/')
  const matched = to.path.match(regex)
  const home = redirect_home_route_names[type]
  const login = redirect_login_route_names[type]
  const is_auth = is_authenticated(type)

  if (type === 'member' && to.name === login && is_auth) {
    return { name: home }
  }

  if (matched !== null && matched.length > 0) {
    if (!is_auth) {
      if (type === 'member') {
        return null
      }

      if (to.name === login) {
        return null
      } else {
        return { name: login }
      }
    } else if (is_auth && to.name === login) {
      return { name: home }
    }
  }

  return null
}

UAParser.prototype.inAppWebView = function () {
  return this.getBrowser().name === 'Goferbro'
}

const uaParser = new UAParser({
  browser: [
    [/(Goferbro)\/(\d.\d.\d)/],
    [UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION]
  ]
})

router.beforeEach((to, from, next) => {

  if (process.env.NODE_ENV === 'production') {
    if (!uaParser.inAppWebView() && to.name !== 'Startapp') {
        if (typeof process.env.VUE_APP_PRODUCTION_PASSWORD === 'undefind' || process.env.VUE_APP_PRODUCTION_PASSWORD === '' || localStorage.getItem('password') !== process.env.VUE_APP_PRODUCTION_PASSWORD) {
          next({name: 'Startapp'})
        }
    }
  }

  store.dispatch('fetchConfig')

  if (to.query.invitationCode) {
    store.commit('setFriendInvitationCode', to.query.invitationCode)
  }

  if (to.meta.hasOwnProperty('guest') && to.meta.guest === true) {
    next()
    return
  }

  let redirect = null

  redirect = verifyToken(to, 'member')

  if (redirect !== null) {
    next(redirect)
    return
  }

  redirect = verifyToken(to, 'distributor')

  if (redirect !== null) {
    next(redirect)
    return
  }

  next()
})

export default router
